import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../utils/type';
import {
  selectStationsByVendor,
  selectStationListLoading,
} from '../pages/stations/services/stationList/selectors';
import { getStationList } from '../pages/stations/services/stationList/crudFunctions';

interface Props {
  vendorId: number | undefined;   // pass current vendor filter value
  value: number | undefined;
  onChange: (stationId: number | undefined) => void;
  label?: string;
}

const StationSelect: React.FC<Props> = ({
  vendorId,
  value,
  onChange,
  label = 'Station',
}) => {
  const dispatch = useDispatch();
  const stations = useSelector((s: RootState) =>
    selectStationsByVendor(vendorId)(s)
  );
  const loading = useSelector((s: RootState) => selectStationListLoading(s));

  // Fetch stations whenever vendorId changes (or on first render)
  useEffect(() => {
    dispatch<any>(getStationList(vendorId));
    // Reset selection when vendor changes
    onChange(undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendorId]);

  return (
    <div>
      <label className="form-label">{label}</label>
      <select
        className="form-select"
        value={value ?? ''}
        onChange={(e) =>
          onChange(e.target.value ? Number(e.target.value) : undefined)
        }
        disabled={loading}
      >
        <option value="">
          {loading ? 'Loading stations...' : 'All Stations'}
        </option>
        {stations.map((s) => (
          <option key={s.id} value={s.id}>
            {s.station_name}
            {s.address ? ` — ${s.address.substring(0, 40)}${s.address.length > 40 ? '…' : ''}` : ''}
          </option>
        ))}
      </select>
    </div>
  );
};

export default StationSelect;
